export class LineRunLocation {
    ID: number;
    Name: string;
    Inactive: boolean;
}

export default LineRunLocation;